import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import classes from './LandingPage.css';
import SchneiderTopBar from '../../components/UI/SchneiderTopBar/SchneiderTopBar';
import LandingMenu from '../../components/LandingMenu/LandingMenu';
import SideBar from '../../components/UI/SideBar/SideBar';

class LandingPage extends Component {
  state = {
    sideMenuTriggered: false
  };

  handleSideBarTrigger = () => {
    this.setState({
      sideMenuTriggered: true
    });
  };

  handleSideBarClose = () => {
    this.setState({
      sideMenuTriggered: false
    });
  };

  render() {
    const {
      language,
      country,
      selectedCanadaEN,
      selectedCanadaFR,
      selectedUSA
    } = this.props;

    return (
      <Fragment>
        <div className={classes.LandingPage}>
          <SchneiderTopBar
            country={country}
            sideMenuTriggered={this.state.sideMenuTriggered}
            sideMenuHandler={this.handleSideBarTrigger}
          />
          <LandingMenu language={language} />
        </div>
        <SideBar
          opened={this.state.sideMenuTriggered}
          closeSideBar={this.handleSideBarClose}
          selectedCanadaEN={selectedCanadaEN}
          selectedCanadaFR={selectedCanadaFR}
          selectedUSA={selectedUSA}
          language={language}
          country={country}
        />
      </Fragment>
    );
  }
}

LandingPage.propTypes = {
  language: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  selectedCanadaEN: PropTypes.func,
  selectedCanadaFR: PropTypes.func,
  selectedUSA: PropTypes.func
};

export default withRouter(LandingPage);
